
import store from '../vuex/store'
import router from '../router'
import Vue from 'vue'
import moment from 'moment'
export const loginSuccess = (result) => {
  console.log(result)
  let userid = result.userid
  let userImage = result.userLogo
  let systemImage = result.systemLogo
  let systemName = result.systemName
  let token = result.token
  let orgName = result.orgName
  // console.log(expiration)
  let roles = result.roles
  let level = result.level
  let orgCoord = {
    coordType: result.homeCoordType,
    point: {
      lng: result.homeLng,
      lat: result.homeLat
    },
    zoom: result.homeLevel
  }
  let {alarmNoticeType} = result
  if (alarmNoticeType) {
    store.dispatch('setAlarmNoticeType', alarmNoticeType)
  }
  if (result.autoRefresh) {
    let expire = parseInt(result.expiration) / 2 + moment().unix()
    // console.log(expire)
    store.dispatch('setToken', {
      token: token,
      expire: expire
    })
  } else {
    localStorage.removeItem('TOKEN_EXPIRE')
    store.dispatch('setToken', {
      token: token
    })
  }
  store.dispatch('setLevel', level)
  localStorage.setItem('orgCoord', JSON.stringify(orgCoord))
  store.dispatch('setOrgCoord', orgCoord)

  store.dispatch('setUser', {
    name: result.username,
    id: userid,
    roles: roles,
    userImage: userImage
  })
  store.dispatch('setOrg', {
    level: level,
    systemImage: systemImage,
    systemName: systemName,
    orgName
  })
  // console.log(roles)
  // console.log(router.push)
  if (roles && (roles === 'SuperAdmin' || roles === 'Integrator')) {
      //key暂时写死,后面应从数据库获取
    Vue.ls.set('activeMenu', 1)
    router.push('/overview')
  }  else{
    Vue.ls.set('activeMenu', 1)
    router.push('/home')
  }
}